<template>
  <div>
    <CCard>
      <CCardHeader>
        <slot name="header">
          <CIcon name="cil-grid" />
          {{title}}
        </slot>
      </CCardHeader>
      <CCardBody>
        <Loading v-if="isLoading"></Loading>

        <div v-else>
          <CForm>
            <CRow>
                <CCol sm="3">
                  <div class="form-group">
                    <label for="Product">Product</label>
                    <model-select
                      class="form-control"
                      id="Product"
                      :options="productList"
                      v-model="$v.productIssueForm.product_code.$model"
                      :isError="$v.productIssueForm.product_code.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="$v.productIssueForm.product_code.$invalid"
                      class="invalid-feedback-custom"
                    >Product should be filled.</div>
                  </div>
                </CCol>


             <CCol sm="3">
                <div class="form-group">
                  <label for="Issue">Issue</label>
                  <model-select
                    class="form-control"
                    id="issue"
                    :options="issueList"
                    v-model="$v.productIssueForm.issue_type.$model"
                    :isError="$v.productIssueForm.issue_type.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                  <div
                    v-if="$v.productIssueForm.issue_type.$invalid"
                    class="invalid-feedback-custom"
                  >Product should be filled.</div>
                </div>
              </CCol>

                <CCol sm="3">
                <div class="form-group">
                  <label for="user">user</label>
                  <model-select
                    class="form-control"
                    id="user"
                    :options="userList"
                    v-model="$v.productIssueForm.user_code.$model"
                    :isError="$v.productIssueForm.user_code.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                  ></model-select>
                  <div
                    v-if="$v.productIssueForm.user_code.$invalid"
                    class="invalid-feedback-custom"
                  >Product should be filled.</div>
                </div>
              </CCol>

            </CRow>
            <CRow>
              <CCol sm="9">
                <label for="nik">Description</label>
                <quill-editor style="height: 200px; margin-bottom:70px;"
                  :content="content"
                  :options="editorOption"
                  v-model="$v.productIssueForm.description.$model"
                  @change="onEditorChange($event)">
                </quill-editor>
                <div v-if="$v.productIssueForm.description.$invalid" class="invalid-feedback-custom">
                  Description harus di isi.
                </div>
                <!-- <CTextarea
                  required
                  rows="4"
                  label="Description"
                  invalid-feedback="Description should be filled"
                  v-model="$v.productIssueForm.description.$model"
                  :is-valid="!$v.productIssueForm.description.$invalid"
                /> -->
              </CCol>
            </CRow>
          </CForm>
        </div>
      </CCardBody>
      <CCardFooter align="right" :border-color="'white'">
        <CRow>
          <CCol sm="12">
            <CButton color="danger" title="Edit" size="sm" class="text-center" @click="back">
              <i class="fa fa-undo"></i> Back
            </CButton>&nbsp;
            <CButton
              color="success"
              :disabled="$v.productIssueForm.$invalid"
              title="Detail"
              size="sm"
              @click="save"
            >
              <i class="fa fa-edit" /> Save
            </CButton>
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard>
  </div>
</template>

<script>
import GlobalTable from "../../../templates/Table";
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "../../../templates/Loading";
import vSelect from "vue-select";
import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import Quill from 'quill'

export default {
  name: "ProductIssueDetail",
  components: { GlobalTable, Loading, quillEditor },
  data() {
    return {
      title: "Product Issue Detail",
      productList: [],
      issueList: [],
      userList: [],
      items: [],
      productIssueForm: tableInterfaces.product_issue,
      isLoading: false,
      activeTab: 0,
      content: '',editorOption: {},	// data quill
    };
  },
  validations: {
    productIssueForm: {
      issue_code: {},
      issue_type: { required },
      product_code: { required },
      user_code: { required },
      description: { required },
      date_inserted: {},
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function (id) {
      this.getDropdown();
      this.getDetailIssue(id);
    },
    back: function () {
      this.$router.go(-1);
    },
    getDetailIssue: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/product_issue/detail/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.productIssueForm = response.data.data;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getDropdown: function () {
      this.axios.get("/console/product_issue/dropdown").then((response) => {
        this.productList = response.data.product;
        this.issueList = response.data.issued_type;
        this.userList = response.data.users;
      });
    },
    save: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah Data ini ?")) {
        this.isLoading = true;
        this.axios
          .put("console/product_issue/update", this.productIssueForm)
          .then((response) => {
            this.showInfoNotification({
              title: "Ubah Product Issue",
              message: response.data.message,
            });
          })
          .catch((error) => {
            this.expired(error, "Ubah Product Issue");
          })
          .finally(() => {
            this.isLoading = false;
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
    onEditorChange({ quill, html, text }) {
      this.content = html
      this.productIssueForm.description = html
    },
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
